import React from 'react';

import {LocationIcon} from '../icons/location-icon';

export const LocationLink = ({link, text, iconProps, style}) => (
  <a
    href={link}
    target='_blank'
    rel='noopener noreferrer'
    className={style}
  >
    <LocationIcon {...iconProps} />
    {text}
  </a>
);
